import type { Customer } from "../../../../models/customer";
import type { CustomerApiDTO } from "../dtos";

export const mapperCustomerDTOtoCustomer = (customerDTO: CustomerApiDTO["data"]): Customer => ({
  _id: customerDTO._id,
  hubspotId: customerDTO.hubspotId,
  address: customerDTO.address,
  alias: customerDTO.alias,
  serviceContracts: mapServiceContracts(customerDTO.serviceContracts),
  city: customerDTO.city,
  contact: customerDTO.contact,
  country: customerDTO.country,
  email: customerDTO.email,
  iban: customerDTO.iban,
  vat: customerDTO.vat,
  name: customerDTO.name,
  origin: customerDTO.origin,
  phone: customerDTO.phone,
  reportsPhone: customerDTO.reportsPhone,
  reportsPhoneSMS: customerDTO.reportsPhoneSMS,
  reportsEmail: customerDTO.reportsEmail,
  state: customerDTO.state,
  zipcode: customerDTO.zipcode,
  disconnectionNotificationEnabled: customerDTO.disconnectionNotificationEnabled,
  annotations: mapAnnotationDTOtoAnnotation(customerDTO.annotations),
  thirdPartyServices: customerDTO.thirdPartyServices,
});

//TODO: Implement history of annotations
const mapAnnotationDTOtoAnnotation = (
  annotations?: CustomerApiDTO["data"]["annotations"]
): string => {
  if (!annotations || annotations.length === 0) return "";
  return annotations[0].message;
};

const mapServiceContracts = (serviceContracts: CustomerApiDTO["data"]["serviceContracts"]) => {
  return serviceContracts.map((serviceContract) => {
    return {
      id: serviceContract.id,
      licenses: serviceContract.licenses.map((license) => ({
        id: license.id,
        name: license.name,
        qty: license.qty,
        activo: license.activo,
        family: "",
      })),
    };
  });
};
